import { api } from "./api"

export function status() {
  return api.get('/status');
}

export function health({ token }) {
  return api.get('/health', {}, token);
}

export function api_translate({ message, source, target, token } = {}) {
  return api.get('/translate', { message, source, target }, token);
}

export function list_news({ skip = 0, limit = 50, show_private = false, date_from, date_to, search_query, language, token } = {}) {
  return api.get('/news', { skip, limit, show_private, date_from, date_to, search_query, language }, token);
}

export function get_news({ news_id, token }) {
  return api.get(`/news/${news_id}`, {}, token);
}

export function get_news_illustration({ news_id, token }) {
  return api.getBinary(`/news/${news_id}/illustration`, {}, token);
}

export function get_news_document({ news_id, token }) {
  return api.getBinary(`/news/${news_id}/document`, {}, token);
}

export async function create_news({
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  private: isPrivate = false,
  illustration,
  document,
  token
}) {
  const formData = new FormData();
  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  formData.append('private', isPrivate.toString());

  if (illustration && illustration instanceof File) formData.append('illustration', illustration);
  if (document && document instanceof File) formData.append('document', document);

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/news`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to create news: ${response.status}`);
  }

  return await response.json();
}

export async function update_news({
  news_id,
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  private: isPrivate,
  illustration,
  document,
  token
}) {
  const formData = new FormData();

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  if (isPrivate !== undefined) formData.append('private', isPrivate.toString());

  if (illustration === 'DELETE') {
    formData.append('delete_illustration', 'true');
  } else if (illustration && illustration instanceof File) {
    formData.append('illustration', illustration);
  }

  if (document === 'DELETE') {
    formData.append('delete_document', 'true');
  } else if (document && document instanceof File) {
    formData.append('document', document);
  }

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/news/${news_id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to update news: ${response.status}`);
  }

  return await response.json();
}

export function delete_news({ news_id, token }) {
  return api.delete(`/news/${news_id}`, {}, token);
}

export function count_news({ show_private = false, date_from, date_to, search_query, language, token } = {}) {
  return api.get('/news/count', { show_private, date_from, date_to, search_query, language }, token);
}

export function list_events({ skip = 0, limit = 50, show_private = false, date_from, date_to, search_query, language, time_filter = "upcoming", token } = {}) {
  return api.get('/event', { skip, limit, show_private, date_from, date_to, search_query, language, time_filter }, token);
}

export function get_event({ event_id, token }) {
  return api.get(`/event/${event_id}`, {}, token);
}

export function get_event_illustration({ event_id, token }) {
  return api.getBinary(`/event/${event_id}/illustration`, {}, token);
}

export function get_event_document({ event_id, token }) {
  return api.getBinary(`/event/${event_id}/document`, {}, token);;
}

export async function create_event({
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  event_start_date,
  event_end_date,
  event_start_time,
  event_end_time,
  private: isPrivate = false,
  location_name,
  location_latitude,
  location_longitude,
  location_address,
  illustration,
  document,
  token
}) {
  console.log('[create_event] Input params:', {
    location_name,
    location_latitude,
    location_longitude,
    location_address
  });

  const formData = new FormData();

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  if (event_start_date) formData.append('event_start_date', event_start_date);
  if (event_end_date) formData.append('event_end_date', event_end_date);
  if (event_start_time) formData.append('event_start_time', event_start_time);
  if (event_end_time) formData.append('event_end_time', event_end_time);

  const privateValue = isPrivate === true || isPrivate === 'true';
  formData.append('private', privateValue.toString());

  if (location_name && location_name.trim()) formData.append('location_name', location_name);

  const latCheck = location_latitude !== undefined && location_latitude !== null && location_latitude !== '' && !isNaN(location_latitude);
  const lngCheck = location_longitude !== undefined && location_longitude !== null && location_longitude !== '' && !isNaN(location_longitude);

  console.log('[create_event] Coordinate checks:', {
    location_latitude,
    location_longitude,
    latCheck,
    lngCheck
  });

  if (latCheck) {
    formData.append('location_latitude', location_latitude.toString());
    console.log('[create_event] Added location_latitude:', location_latitude.toString());
  }
  if (lngCheck) {
    formData.append('location_longitude', location_longitude.toString());
    console.log('[create_event] Added location_longitude:', location_longitude.toString());
  }
  if (location_address && location_address.trim()) formData.append('location_address', location_address);

  if (illustration && illustration instanceof File) formData.append('illustration', illustration);
  if (document && document instanceof File) formData.append('document', document);

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/event`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    if (Array.isArray(error.detail)) {
      const errorMessages = error.detail.map(e => `${e.loc?.join('.')} - ${e.msg}`).join('; ');
      throw new Error(errorMessages || `Failed to create event: ${response.status}`);
    }
    throw new Error(error.detail || `Failed to create event: ${response.status}`);
  }

  return await response.json();
}

export async function update_event({
  event_id,
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  event_start_date,
  event_end_date,
  event_start_time,
  event_end_time,
  private: isPrivate,
  location_name,
  location_latitude,
  location_longitude,
  location_address,
  illustration,
  document,
  token
}) {
  console.log('[update_event] Input params:', {
    event_id,
    location_name,
    location_latitude,
    location_longitude,
    location_address
  });

  const formData = new FormData();

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  if (event_start_date !== undefined) formData.append('event_start_date', event_start_date);
  if (event_end_date !== undefined) formData.append('event_end_date', event_end_date);
  if (event_start_time !== undefined) formData.append('event_start_time', event_start_time);
  if (event_end_time !== undefined) formData.append('event_end_time', event_end_time);

  if (isPrivate !== undefined) formData.append('private', isPrivate.toString());
  if (location_name !== undefined) formData.append('location_name', location_name);

  if (location_latitude !== undefined && location_latitude !== null) {
    const latValue = location_latitude === '' ? '' : location_latitude.toString();
    formData.append('location_latitude', latValue);
    console.log('[update_event] Added location_latitude:', latValue);
  }
  if (location_longitude !== undefined && location_longitude !== null) {
    const lngValue = location_longitude === '' ? '' : location_longitude.toString();
    formData.append('location_longitude', lngValue);
    console.log('[update_event] Added location_longitude:', lngValue);
  }
  if (location_address !== undefined) formData.append('location_address', location_address);

  if (illustration === 'DELETE') {
    formData.append('delete_illustration', 'true');
  } else if (illustration && illustration instanceof File) {
    formData.append('illustration', illustration);
  }

  if (document === 'DELETE') {
    formData.append('delete_document', 'true');
  } else if (document && document instanceof File) {
    formData.append('document', document);
  }

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/event/${event_id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to update event: ${response.status}`);
  }

  return await response.json();
}

export function delete_event({ event_id, token }) {
  return api.delete(`/event/${event_id}`, {}, token);
}

export function count_events({ show_private = false, date_from, date_to, search_query, language, time_filter = "upcoming", token } = {}) {
  return api.get('/event/count', { show_private, date_from, date_to, search_query, language, time_filter }, token);
}

export function get_user_info({ token }) {
  if (!token) return Promise.resolve(null);
  return api.get(`/user`, {}, token);
}

export function list_user_events({ skip = 0, limit = 50, token } = {}) {
  return api.get('/user/events', { skip, limit }, token);
}

export async function register_for_event({ event_id, token }) {
  const formData = new FormData();

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/event/${event_id}/register`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to register for event: ${response.status}`);
  }

  return await response.json();
}


export function unregister_from_event({ event_id, token } = {}) {
  return api.delete(`/event/${event_id}/unregister`, {}, token);
}


export function list_pages({ skip = 0, limit = 50, show_private = false, search_query, language, token } = {}) {
  return api.get('/page', { skip, limit, show_private, search_query, language }, token);
}

export function get_page({ page_id, token }) {
  return api.get(`/page/${page_id}`, {}, token);
}

export async function create_page({
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  private: isPrivate = false,
  token
}) {
  const formData = new FormData();

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  formData.append('private', isPrivate.toString());

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/page`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to create page: ${response.status}`);
  }

  return await response.json();
}

export async function update_page({
  page_id,
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  private: isPrivate,
  token
}) {
  const formData = new FormData();

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  if (isPrivate !== undefined) formData.append('private', isPrivate.toString());

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/page/${page_id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to update page: ${response.status}`);
  }

  return await response.json();
}

export function delete_page({ page_id, token }) {
  return api.delete(`/page/${page_id}`, {}, token);
}

// ==================== DOCUMENT FUNCTIONS ====================

export function get_page_documents({ page_id, token }) {
  return api.get(`/page/${page_id}/documents`, {}, token);
}

export function get_document({ document_id, token }) {
  return api.get(`/document/${document_id}`, {}, token);
}

export function get_document_file({ document_id, token }) {
  return api.getBinary(`/document/${document_id}/file`, {}, token);
}

export async function create_document({
  page_id,
  title_en,
  title_cz,
  title_de,
  private: isPrivate = false,
  document,
  token
}) {
  const formData = new FormData();

  if (page_id !== undefined && page_id !== null && page_id !== '') formData.append('page_id', page_id.toString());

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  formData.append('private', isPrivate.toString());

  if (document && document instanceof File) formData.append('document', document);

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/document`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to create document: ${response.status}`);
  }

  return await response.json();
}

export async function update_document({
  document_id,
  page_id,
  clear_page,
  title_en,
  title_cz,
  title_de,
  private: isPrivate,
  document,
  token
}) {
  const formData = new FormData();

  if (clear_page) {
    formData.append('clear_page', 'true');
  } else if (page_id !== undefined && page_id !== null && page_id !== '') {
    formData.append('page_id', page_id.toString());
  }

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (isPrivate !== undefined) formData.append('private', isPrivate.toString());

  if (document === 'DELETE') {
    formData.append('delete_document', 'true');
  } else if (document && document instanceof File) {
    formData.append('document', document);
  }

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/document/${document_id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to update document: ${response.status}`);
  }

  return await response.json();
}

export function delete_document({ document_id, token }) {
  return api.delete(`/document/${document_id}`, {}, token);
}

// ==================== IMAGE FUNCTIONS ====================

export function get_page_images({ page_id, token }) {
  return api.get(`/page/${page_id}/images`, {}, token);
}

export function get_image({ image_id, token }) {
  return api.get(`/image/${image_id}`, {}, token);
}

export function get_image_file({ image_id, token }) {
  return api.getBinary(`/image/${image_id}/file`, {}, token);
}

export async function create_image({
  page_id,
  title_en,
  title_cz,
  title_de,
  private: isPrivate = false,
  image,
  token
}) {
  const formData = new FormData();

  if (page_id !== undefined && page_id !== null && page_id !== '') formData.append('page_id', page_id.toString());

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  formData.append('private', isPrivate.toString());

  if (image && image instanceof File) formData.append('image', image);

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/image`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to create image: ${response.status}`);
  }

  return await response.json();
}

export async function update_image({
  image_id,
  page_id,
  clear_page,
  title_en,
  title_cz,
  title_de,
  private: isPrivate,
  image,
  token
}) {
  const formData = new FormData();

  if (clear_page) {
    formData.append('clear_page', 'true');
  } else if (page_id !== undefined && page_id !== null && page_id !== '') {
    formData.append('page_id', page_id.toString());
  }

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (isPrivate !== undefined) formData.append('private', isPrivate.toString());

  if (image === 'DELETE') {
    formData.append('delete_image', 'true');
  } else if (image && image instanceof File) {
    formData.append('image', image);
  }

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/image/${image_id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to update image: ${response.status}`);
  }

  return await response.json();
}

export function delete_image({ image_id, token }) {
  return api.delete(`/image/${image_id}`, {}, token);
}

// ==================== SECTION FUNCTIONS ====================

export function get_page_sections({ page_id, token }) {
  return api.get(`/page/${page_id}/sections`, {}, token);
}

export function get_section({ section_id, token }) {
  return api.get(`/section/${section_id}`, {}, token);
}

export async function create_section({
  page_id,
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  private: isPrivate = false,
  token
}) {
  const formData = new FormData();

  formData.append('page_id', page_id.toString());

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  formData.append('private', isPrivate.toString());

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/section`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to create section: ${response.status}`);
  }

  return await response.json();
}

export async function update_section({
  section_id,
  page_id,
  title_en,
  title_cz,
  title_de,
  text_en,
  text_cz,
  text_de,
  private: isPrivate,
  token
}) {
  const formData = new FormData();

  if (page_id !== undefined) formData.append('page_id', page_id.toString());

  if (title_en !== undefined) formData.append('title_en', title_en);
  if (title_cz !== undefined) formData.append('title_cz', title_cz);
  if (title_de !== undefined) formData.append('title_de', title_de);

  if (text_en !== undefined) formData.append('text_en', text_en);
  if (text_cz !== undefined) formData.append('text_cz', text_cz);
  if (text_de !== undefined) formData.append('text_de', text_de);

  if (isPrivate !== undefined) formData.append('private', isPrivate.toString());

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/section/${section_id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Failed to update section: ${response.status}`);
  }

  return await response.json();
}

export function delete_section({ section_id, token }) {
  return api.delete(`/section/${section_id}`, {}, token);
}